var _classCallCheck = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _assertThisInitialized = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var Base = require('./Base'); // TODO: use typescript


var Account = /*#__PURE__*/function (_Base) {
  "use strict";

  _inherits(Account, _Base);

  var _super = _createSuper(Account);

  /**
  * NOTE:
  *   - _temp prop will be used for easy development at the moment to keep account data
  *   - _stats will be used only at the client model for easier access to account data from 
  *   smart contracts (balance of rth/adx, register status, approved adx for transfer etc...)        
  */
  function Account() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$email = _ref.email,
        email = _ref$email === void 0 ? '' : _ref$email,
        _ref$identity = _ref.identity,
        identity = _ref$identity === void 0 ? {
      address: '',
      status: 'pending',
      currentPrivileges: {},
      isLimitedVolume: true,
      relayerData: {},
      validatorAuthTokens: {}
    } : _ref$identity,
        _ref$wallet = _ref.wallet,
        wallet = _ref$wallet === void 0 ? {
      authSig: '',
      // Signature for adex-market session
      signType: '',
      // Sing type (Eip, Trezor, personal, etc..)
      authType: '',
      // Auth type (Metamask, Trezor, Ledger, Local) 
      lsKey: '',
      path: '',
      // We are going to keep the entire path instead using path + index
      chainId: null,
      // need this for hd wallets
      balanceEth: '0',
      balanceDai: '0',
      // To unlock local wallet
      email: '',
      password: ''
    } : _ref$wallet,
        _ref$temp = _ref.temp,
        temp = _ref$temp === void 0 ? {} : _ref$temp,
        _ref$stats = _ref.stats,
        stats = _ref$stats === void 0 ? {
      walletAddress: '',
      walletAuthType: '',
      walletPrivilege: '',
      walletBalanceEth: '',
      walletBalanceDai: '',
      identityAddress: '',
      identityBalanceEth: '',
      identityBalanceDai: '',
      identityPrivileges: ''
    } : _ref$stats,
        _ref$settings = _ref.settings,
        settings = _ref$settings === void 0 ? {} : _ref$settings;

    _classCallCheck(this, Account);

    _this = _super.call(this);
    _this.email = email;
    _this.identity = identity;
    _this.wallet = wallet;
    _this.stats = stats; // UI settings (gasPrice , etc...)

    _this.settings = settings; // Temp we will keep here some addr data 

    _this.temp = temp;
    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  return Account;
}(Base);

module.exports = Account;